import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 站点类型
 */
class Type extends UltMeta {
    LONG_TERM_FUEL = new Meta(1, "中长燃");
    PRIVATELY_OWNED = new Meta(2, "私营");
}

export const OIL_SITE_TYPE = new Type();

/**
 * 站点状态
 */
class State extends UltMeta {
    ENABLE = new Meta(1, "已启用");
    DISABLE = new Meta(0, "已禁用");
}

export const OIL_SITE_STATE = new State();
